
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 396 481"}},[_c('path',{attrs:{"fill":"#FFEB99","d":"M0 0c261.585 89.26 392.378 164.786 392.378 226.581 0 92.693 17.411 79.04-33.965 151.269-34.25 48.152-83.146 82.388-146.687 102.705H30.844L0 377.85V0z"}})])
      }
    
      }
    